<script lang="ts" setup>
import { MediaImageFragment, ToccoModuleFieldsFragment } from '~/api/graphql/generated'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

//TODO: add type
const props = defineProps<{
  entity: ToccoModuleFieldsFragment & {
    fieldToccoData: any
  }
}>()

const modalController = useModal()

const formattedPrice = computed(() => {
  if (!props.entity.fieldToccoData.paths.course_price?.value) {
    return 'CHF 0'
  }
  const price = props.entity.fieldToccoData.paths.course_price.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  return `CHF ${price}`
})

//TODO: add types
const lecturers = computed(() =>
  props.entity.fieldLecturers?.map((userData: any) => {
    const user = userData.entity
    const fullName = `${user.fieldFirstName} ${user.fieldLastName}`
    return {
      image: (user.fieldProfilePicture?.entity as MediaImageFragment) || {
        fieldMediaImage: { url: '/tocco-user-placeholder.png', height: 135, width: 135 },
      },
      name: fullName,
      position: user.fieldLecturerFunction,
    }
  }),
)
</script>

<template>
  <div class="teaser-details">
    <div class="left">
      <h4 class="title">
        {{ entity.title }}
      </h4>
      <span class="open-overlay" @click="modalController.open">
        <Button secondary>{{ t('tocco.detail.openOverlay') }}</Button>
      </span>

      <ToccoModuleModal :controller="modalController">
        <div class="modal-content">
          <h6>
            {{ t(`tocco.toccoTypes.${entity.__typename}`) }}
          </h6>
          <h1>{{ entity.title }}</h1>

          <div class="description">
            <Introtext :text="entity.fieldToccoData.paths.description.value" />
          </div>

          <div class="accordion">
            <ToccoAccordion :entity="entity" />
          </div>
          <div v-if="lecturers?.length" class="persons">
            <ToccoContactPersonsModal :title="t('tocco.detail.lecturersTitle')" :persons="lecturers" />
          </div>
        </div>
      </ToccoModuleModal>
    </div>
    <div class="right">
      <h4 class="price">
        {{ formattedPrice }}
      </h4>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.teaser-details {
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;

  padding: 20px 28px 28px;
  background: var(--c-background-light);
  border-bottom: 1px solid var(--c-line-light);

  @include breakpoint(tl) {
    grid-template-columns: 1fr auto;
    padding: 40px 48px 48px;
  }

  .title,
  .price {
    @include fluid(font-size, 18px, 24px);
    @include fluid(font-size, 24px, 28px);
  }
}

.modal-content {
  max-width: 840px;
  width: 100%;
  margin: 0 auto;
}

h6 {
  margin-bottom: 30px;
}

.description {
  color: var(--c-primary);

  margin-bottom: 40px;

  @include breakpoint(tl) {
    margin-bottom: 20px;
  }
}

.accordion {
  padding: 35px 0;
}
</style>
